export default __webpack_public_path__ + "static/media/hub-cenefa.fc1febfa.JPG";